import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ScrollPanel } from 'primereact/scrollpanel';
import useWindowDimensions from '../hooks/useDimensions';
import axios from 'axios';
import apis from '../../api';
import Base64Downloader from 'common-base64-downloader-react';
import { Dialog } from 'primereact/dialog';
import { PDFDocument } from 'pdf-lib';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import PhoneAuth from '../../helpers/PhoneAuth';
import { InputMask } from "primereact/inputmask";
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';
import { TablePaginator, tablePaginator } from '../TablePaginator/TablePaginator';
import useUserIP from '../../helpers/useUserIP';
import Webcam from 'react-webcam';


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const DocumentSigning = () => {
    const [file, setFile] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const canvasRef = useRef([]);
    const fileUploadRef = useRef(null);
    const toast = useRef(null);

    const { width, height } = useWindowDimensions()

    const [image, setImage] = useState(null);
    const [draggedImage, setDraggedImage] = useState(null);
    const [imagePosition, setImagePosition] = useState(null); // Store image position
    const imageUploadRef = useRef(null);

    const [sendFile, setSendFile] = useState("")
    const [sendImage, setSendImage] = useState("")
    const [hasSign, setHasSign] = useState("")
    const [canUseImage, setCanUseImage] = useState("")
    const [ciudad, setCiudad] = useState("")
    const [pais, setPais] = useState("")
    const [signedFile, setSignedFile] = useState("")
    const [fileName, setFileName] = useState("")

    const [document, setDocument] = useState("")

    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenSign, setIsOpenSign] = useState(false);
    const [isOpenDownload, setIsOpenDownload] = useState(false);
    const [isOpenPhoto, setIsOpenPhoto] = useState(false);

    const [loadingModal, setLoadingModal] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    const [rows, setRows] = useState([]);
    const [products, setProducts] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const { phone, setPhone, otp, setOtp, confirmation, setConfirmation, sendOtp, verifyOtp, toastOtp, isOpenOtp, setIsOpenOtp,
        mailConfirmation, setMailConfirmation, mailOtp, setMailOtp, verifyMailOtp, sendMailOtp, loadVerify, setLoadVerify, loadOtp, setLoadOtp, isValid, setIsValid, captchaKey
    } = PhoneAuth()

    const [mailChecked, setMailChecked] = useState(false)
    const [phoneChecked, setPhoneChecked] = useState(false)

    const headers = {
        authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json; charset=UTF-8'
    }

    const [warnMsg, setWarnMsg] = useState("")
    const ip = useUserIP();

    const [photo, setPhoto] = useState(null)

    const isMobile = width <= 768;
    const isTablet = width > 768 && width < 1024;

    const videoConstraints = isMobile
        ? {
            facingMode: "user",
            aspectRatio: 16 / 9,
            // no width/height — let the browser use the camera's native resolution
        }
        : {
            facingMode: "user",
            aspectRatio: 16 / 9,
            width:  { ideal: 1280 },
            height: { ideal: 720  },
        };
    
    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    const upscaleImage = (base64Image, scaleFactor = 2) => {
        return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width  = img.width  * scaleFactor;
            canvas.height = img.height * scaleFactor;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL("image/jpeg", 0.9));
        };
        img.src = base64Image;
        });
    };


    // mostrar modal
    const showModal = () => {
        setIsOpen(true);
    };

    // ocultar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    // mostrar modal
    const showModalSign = () => {
        setIsOpenSign(true);
    };

    // ocultar modal
    const hideModalSign = () => {
        setIsOpenSign(false);
        setFile(null)
        setHasSign("")
        setCanUseImage("")
        setDraggedImage(null)
        setImagePosition(null)
    };

    // mostrar modal
    const showModalDownload = () => {
        setIsOpenDownload(true);
    };

    // ocultar modal
    const hideModalDownload = () => {
        setIsOpenDownload(false);
        setSignedFile("")
    };

    // mostrar modal
    const showModalPhoto = () => {
        setPhoto(null)
        setIsOpenPhoto(true);
    };

    // ocultar modal
    const hideModalPhoto = () => {
        setIsOpenPhoto(false);
    };

    useEffect(() => {
        handleLocation()
        setTable()
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = TablePaginator()

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} disabled={!filters1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" style={{ width: '6rem' }} value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NOVELTY_DESC': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    function handleLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {
            console.log("Geolocation not supported");
        }
    }

    async function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GEO}`;

        try {
            const response = await axios.get(url);
            const results = response.data.results;

            if (results.length > 0) {
                const addressComponents = results[0].address_components;
                const countryComponent = addressComponents.find(component =>
                    component.types.includes('country')
                );
                const cityComponent = addressComponents.find(component =>
                    component.types.includes('locality') || component.types.includes('administrative_area_level_2')
                );
                console.log(countryComponent)
                console.log(cityComponent)
                if (countryComponent) {
                    setPais(countryComponent.long_name);
                }
                if (cityComponent) {
                    setCiudad(cityComponent.long_name)
                }
            }
        } catch (error) {
            console.error('Error fetching the country name:', error);
        }
        console.log(position)

    }

    function error() {
        console.log("No se puede obtener la localizacion");
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const getImageDimensions = (blobUrl) => {
        console.log(blobUrl)
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                // The image is loaded, now you can access its width and height
                const width = img.width;
                const height = img.height;
                console.log(width, height)
                resolve({ width, height });
            };

            img.onerror = reject;

            // Set the image src to the Blob URL
            img.src = blobUrl;
        });
    };

    const drawImageOnCanvas = (x, y, pageIndex) => {
        if (!image) return;
        const res = getImageDimensions(image.src).then(({ width, height }) => {
            console.log(res)
            const canvas = canvasRef.current[pageIndex];
            const ctx = canvas.getContext('2d');
            if (width > 150 || height > 150) {
                const aspectRatio = width / height;

                if (width > height) {
                    width = 150;
                    height = width / aspectRatio;
                } else {
                    height = 150;
                    width = height * aspectRatio;
                }
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas before drawing
            ctx.drawImage(image, x, y, width, height); // Adjust the size as needed
            setImagePosition({ x, y, pageIndex }); // Store the position after drawing
        })
    };

    const handleCanvasDragOver = (e) => {
        e.preventDefault();
    };

    const handleCanvasDrop = (e, pageIndex) => {
        e.preventDefault();
        if (!draggedImage) return;
        const canvas = canvasRef.current[pageIndex];
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        drawImageOnCanvas(x, y, pageIndex);
    };

    const undoImageDrop = () => {
        if (imagePosition) {
            const { pageIndex } = imagePosition;
            const canvas = canvasRef.current[pageIndex];
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas to remove the image
            setImagePosition(null); // Reset the position to allow re-dropping
        }
        setImagePosition(null)
    };

    const onTemplateSelect = (e) => {
        let files = e.files;
        if (files.length > 0) {
            const fileUrl = URL.createObjectURL(files[0]);
            setSendFile(files[0])
            setFile(fileUrl);
        }
    };

    const onTemplateRemove = (file, callback) => {
        setFile(null);
        callback();
    };

    const onTemplateClear = () => {
        setFile(null);
        setImagePosition(null)
    };

    const onImageTemplateSelect = (e) => {
        let files = e.files;
        if (files.length > 0) {
            const img = new Image();
            img.src = URL.createObjectURL(files[0]);
            img.onload = () => setImage(img);
            setSendImage(files[0])
        }
    };

    const onImageTemplateRemove = (file, callback) => {
        setImage(null);
        setDraggedImage(null)
        setImagePosition(null); // Clear the image position when removing the image
        callback();
    };

    const onImageTemplateClear = () => {
        setImage(null);
        setDraggedImage(null)
        setImagePosition(null); // Clear the image position when clearing the image
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {cancelButton}
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-upload', iconOnly: false, className: 'custom-choose-btn p-button-rounded', style: { width: '10rem' } };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: false, className: 'custom-cancel-btn p-button-danger p-button-rounded', style: { width: '10rem' } };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                    </span>
                </div>
            </div>
        );
    };

    const itemImageTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100}
                        draggable
                        onDragStart={() => setDraggedImage(image)}
                        style={{ width: '100px', cursor: 'pointer' }} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                    </span>
                </div>
            </div>
        );
    };

    const exportPdfWithImageToBase64 = async () => {
        const existingPdfBytes = await fetch(file).then(res => res.arrayBuffer()); // Load the original PDF file

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();

        const canvases = canvasRef.current;

        // Iterate through each canvas (page) and add the drawn images to the PDF
        for (let index = 0; index < canvases.length; index++) {
            const canvas = canvases[index];
            const ctx = canvas.getContext('2d');

            // Convert canvas to image data URL
            const imageDataUrl = canvas.toDataURL('image/png');

            // Embed the image into the PDF
            const page = pages[index];
            const imgData = await pdfDoc.embedPng(imageDataUrl);

            // Draw the image on the PDF page (adjust x, y, width, height as needed)
            console.log(imagePosition)
            page.drawImage(imgData, {
                x: 0,
                y: page.getHeight() - 842,
                width: 595,
                height: 842,
            });
        }

        // Serialize the PDF document to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save();

        // Convert PDF to base64
        let base64Pdf = btoa(
            pdfBytes.reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        base64Pdf = 'data:application/pdf;base64,' + base64Pdf
        // console.log(base64Pdf)
        // setFileName(sendFile.name)
        return base64Pdf;
    };

    const putSignature = async (file) => {
        const payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            DOCUMENT_ID: document,
            DOCUMENT: file
        }
        try {
            await apis.putContractSignature(payload, headers).then(res => {
                showModal()
                setLoading(false)
                hideModalSign()
                setPhoto(null)
                setTable()
            })
        }
        catch (err) {
            console.log(err)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading(false)
        }
    }

    const signFile = async () => {
        setLoading(true)
        const base64file = await exportPdfWithImageToBase64()
        let base64Image = ""

        // let reader = new FileReader();
        // const data = await fetch(file)
        // const blob = await data.blob()
        // console.log(data)
        // reader.readAsDataURL(blob);
        // reader.onloadend = function () {
        //     base64file = reader.result;
        //     console.log(base64file);
        // }

        // await fileToBase64(sendFile).then(res => {
        //     setFileName(sendFile.name)
        //     base64file = res
        // })
        // await fileToBase64(sendImage).then(res => {
        //     base64Image = res
        // })

        let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
        console.log(date)
        let newDate = ""
        for (let i = 0; i < date.length; i++) {
            if (date.charCodeAt(i) <= 127) {
                newDate += date.charAt(i);
            }
        }

        const document_ = {
            "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Usuario": localStorage.getItem('name'),
            "/Aplicacion": "Remuner BPO",
            "/Responsable": "Remuner",
            "/Fecha": newDate,  
            "/IP": ip ? ip : "",
            "/Identification": localStorage.getItem('number_id'),
            "/NumeroDocumento": document,
            "/Correo": localStorage.getItem('user'),
            "/Foto": photo ? photo : "",
        }

        const payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            PARAMS: [{
                FILE: base64file,
                DOCUMENT: document_,
                URL: process.env.REACT_APP_VALIDATE_URL
            }]
        }

        try {
            await apis.documentSignature(payload, headers).then(res => {
                setSignedFile(res.data.FILE)
                putSignature(res.data.FILE)
            })
            // await apis.pythonTest(payload, 'PDF.FirmDocument').then(res => {
            //     setSignedFile(res.data.FILE)
            //     showModal()
            //     setLoading(false)
            // })
        }
        catch (err) {
            console.log(err)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading(false)
        }
    }

    const setTable = async () => {
        try {
            await apis.getContractDocuments(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('contract_id'), headers).then(res => {
                let data = res.data.DOCUMENTS
                let rows_ = []
                data.forEach(row => {
                    let newRow = {
                        ...row,
                        DOCUMENT_TYPE_ID: row.DOCUMENT_TYPE.split('|')[0],
                        DOCUMENT_TYPE: row.DOCUMENT_TYPE.split('|')[1],
                        SIGNATURE_DESC: row.SIGNATURE === 'S' ? 'Si' : 'No',
                        STATUS_ID: row.STATUS.split('|')[0],
                        STATUS: row.STATUS.split('|')[1],
                    }
                    rows_.push(newRow)
                })
                setRows(rows_)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
        }
    }

    const getFileUrl = async (document, name, action) => {
        try {
            await apis.getContractFile(localStorage.getItem('entity'), localStorage.getItem('client'), document, headers).then(res => {
                // const fileUrl = URL.createObjectURL(res.data.URL);
                setSendFile(res.data.URL)
                setFile(res.data.URL);
                setFileName(name)
                if (action === 'firmar') {
                    setLoadingModal(false)
                    if (localStorage.getItem('sign_photo') === 'S') {
                        showModalPhoto()
                    }
                    else{
                        showModalSign()
                    }
                }
                else {
                    setSignedFile(res.data.URL)
                    setLoadingModal(false)
                    showModalDownload()
                    console.log("asasa")
                }
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const getSignature = async (document, name, action) => {
        setDocument(document)
        setIsOpenOtp(false)
        setLoadingModal(true)
        try {
            if (action === "firmar") {
                await apis.getContractSignature(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('contract_id'), headers).then(res => {
                    let _img = res.data.IMAGE
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = _img;
                    img.onload = () => setImage(img);
                    console.log(img)
                    setHasSign(res.data.SIGNATURE_IMG)
                    setCanUseImage(res.data.USE_SIGNATURE ? res.data.USE_SIGNATURE : "")
                    setSendImage(_img)
                    getFileUrl(document, name, action)
                })
            }
            else {
                getFileUrl(document, name, action)
            }
            clear()
            setLoadingModal(false)
        }
        catch (err) {
            console.log(err)
            setLoadingModal(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const getPhone = async () => {
        try {
            await apis.getIdentity(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('number_id'), localStorage.getItem('token'), headers).then(res => {
                let data = res.data.PERSON[0]
                setPhone(data.CELL_PHONE1 ? data.CELL_PHONE1 : "")
                setWarnMsg(data.CELL_PHONE1 ? "" : "La opción de solicitar el código mediante teléfono no se encuentra habilitada debido a que no cuentas con un número de teléfono registrado. Por favor comunicáte con gestión humana")
                setIsOpenOtp(true)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const checkOtp = async (rowData) => {
        try{
            setDocument(rowData.DOCUMENT_ID);
            setFileName(rowData.NAME_FILE)
            await apis.getVerificationCodeOtp('SMS', headers).then(res => {
                if(res.data.VIGENTE === 'S'){
                    getSignature(rowData.DOCUMENT_ID, rowData.NAME_FILE, 'firmar')
                }
                else{
                    getPhone()
                }
            })
        }
        catch(err){
            console.log(err)
            setLoadingModal(false)
            setIsOpenOtp(false)
        }
    }

    const addFooter = (
        <div>
            <Button onClick={hideModalSign} label='Cancelar'></Button>
            <Button disabled={hasSign === 'N' ? (canUseImage === "N" || canUseImage ===  "" ? !file : !(draggedImage && file)) : !(draggedImage && file)} loading={loading} className='custom-cancel-btn p-button-success p-button-rounded mt-1' label="Firmar" icon="pi pi-check" onClick={signFile} />
        </div>
    );

    const otpFooter = (
        <div>
            <Button onClick={() => { setIsOpenOtp(false); clear() }} label='Cancelar'></Button>
            {isValid && <Button loading={loading} className='custom-cancel-btn p-button-success p-button-rounded mt-1' label="Firmar" icon="pi pi-check" onClick={() => getSignature(document, fileName, 'firmar')} />}
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row'>
                <Button icon="pi pi-align-justify" className="p-button-info mr-2 p-button-sm text-xs" onClick={() => getSignature(rowData.DOCUMENT_ID, rowData.NAME_FILE, 'descargar')} tooltip="Consultar" />
                {rowData.STATUS_ID === 'PEN' &&
                    <Button icon="pi pi-pen-to-square" className="p-button-success mr-2 p-button-sm text-xs" onClick={() => {
                        checkOtp(rowData)
                    }} tooltip="Firmar" />}
            </div>
        )
    }

    const handleCheckboxChange = (checked, value) => {
        console.log(value, checked)
        if (value === 'MAIL') {
            setMailChecked(checked)
            if (checked) {
                if (phoneChecked) {
                    setPhoneChecked(!checked)
                }
            }
        }
        else if (value === 'PHONE') {
            setPhoneChecked(checked)
            if (checked) {
                if (mailChecked) {
                    setMailChecked(!checked)
                }
            }
        }
        // Actualizar el estado del checkbox correspondiente
        // value === 'MAIL' ? setMailChecked(checked) : setPhoneChecked(checked);
    };

    const clear = () => {
        setOtp("")
        setMailOtp("")
        setConfirmation(null)
        setMailConfirmation(false)
        setIsValid(false)
        setMailChecked(false)
        setPhoneChecked(false)
        setPhone("")
    }


    const photoFooter = (
        <div>
            {photo &&
            <div className='flex flex-row gap-1 flex-wrap'>
                <Button onClick={hideModalPhoto} label='Cancelar' severity="danger" />
                <Button onClick={() => setPhoto(null)} label='Reintentar' />
                <Button label='Continuar' onClick={() => { showModalSign(); hideModalPhoto() }} severity='success'/>
            </div>}
        </div>
    );

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8'>
            <Toast ref={toast} />
            <div style={{ marginBottom: "2rem", marginTop: "5rem" }} className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <span className="text-900">Gestión documentos de contrato</span>
            </div>
            <Dialog footer={addFooter} visible={isOpenSign} position="top" draggable={false} resizable={false} modal onHide={hideModalSign}>
                <div className='flex flex-row scrollpanel-demo justify-content-between' style={{ width: '100%' }}>
                    {(hasSign === 'S' || (hasSign === 'N' && canUseImage === "S")) && <div className='ml-4'>
                        <span className="text-900 font-bold text-xl">Firma</span>
                        <br />
                        {image && <div className="flex align-items-center flex-wrap">
                            <div className="flex align-items-center" style={{ width: '40%' }}>
                                <img alt={'Firma'} role="presentation" src={image.src} width={100}
                                    draggable
                                    onDragStart={() => setDraggedImage(image)}
                                    style={{ width: '100px', cursor: 'pointer' }} />
                            </div>
                        </div>}
                        {imagePosition && (
                            <div style={{ marginTop: "1rem" }}>
                                <Button className='custom-cancel-btn p-button-danger p-button-rounded mt-1' label="Deshacer firma" icon="pi pi-undo" onClick={undoImageDrop} />
                            </div>
                        )}
                    </div>}
                    <ScrollPanel
                        className="custombar1"
                        style={{
                            // ...(open ? styleOpen : styleClose),
                            marginTop: '1rem',
                            marginLeft: '1rem',
                            height: '80vh',
                            width: width >= 1024 ? '33vw' : '60vw',
                            textAlign: 'left !important',
                            backgroundColor: 'white'
                            // display: 'flex',
                            // flexWrap: 'wrap'
                        }}>
                        {file && <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                            {Array.from({ length: numPages }, (el, index) => (
                                <div key={`page_${index + 1}`} style={{ position: 'relative' }}>
                                    <Page pageNumber={index + 1} renderTextLayer={false} />
                                    <canvas
                                        ref={(el) => (canvasRef.current[index] = el)}
                                        style={{ position: 'absolute', top: 0, left: 0 }}
                                        width={595}
                                        height={842}
                                        onDragOver={handleCanvasDragOver}
                                        onDrop={(e) => handleCanvasDrop(e, index)}
                                    />
                                    <br />
                                </div>
                            ))}
                        </Document>}
                    </ScrollPanel>
                    {width >= 1024 && <video src='https://remuner.s3-us-east-2.amazonaws.com/fuentes/firma/Firma.mp4'
                        style={{
                            width: width * 0.4,
                            height: height * 0.6
                        }}
                        autoPlay
                        muted loop />}
                </div>
            </Dialog>
            <Dialog visible={isOpen} header={"Descargar documento firmado"}
                position="top" draggable={false} resizable={false} modal onHide={hideModal}>
                <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + signedFile} downloadName={fileName.split('.')[0] + "_firmado"} onDownloadSuccess={() => { hideModal() }}>
                    <Button icon="pi pi-download" label='Descargar' />
                </Base64Downloader>
            </Dialog>
            <Dialog visible={isOpenDownload} header={"Descargar documento"}
                position="top" draggable={false} resizable={false} modal onHide={hideModalDownload}>
                <Button icon="pi pi-download" label='Descargar' onClick={() => window.open(signedFile, "_blank")} />
            </Dialog>
            <Dialog visible={loadingModal} header={"Cargando..."}
                position="top" draggable={false} resizable={false} modal onHide={() => setLoadingModal(false)}>
                <ProgressSpinner />
            </Dialog>
            <Dialog visible={isOpenOtp} header={"Autenticación de dos pasos"} footer={otpFooter}
                position="top" draggable={false} resizable={false} modal onHide={() => { setIsOpenOtp(false); clear() }}>
                <Toast ref={toastOtp} />
                <span>Seleccione el medio por el cual desea recibir el código de verificación:</span><br /><br />
                <div className="flex flex-wrap justify-content-start gap-2">
                    <div className="flex align-items-center">
                        <Badge className="ml-2 mr-1" value="Correo" size="medium" severity="info" />
                        <Checkbox inputId="IN" value="MAIL" className='check-in' onChange={(e) => {
                            handleCheckboxChange(e.checked, e.value)
                        }}
                            checked={mailChecked} />
                    </div>
                    <div className="flex align-items-center">
                        <Badge className="ml-1 mr-1" value="Teléfono" size="medium" severity="info" />
                        <Checkbox inputId="OUT" value="PHONE" className='check-out' onChange={(e) => {
                            handleCheckboxChange(e.checked, e.value)
                        }} disabled={!phone}
                            checked={phoneChecked} />
                    </div>
                    {(phoneChecked || mailChecked) &&
                        <Button onClick={phoneChecked ? sendOtp : sendMailOtp} loading={loadOtp} label='Solicitar código' disabled={!phoneChecked && !mailChecked}
                            className="p-1 flex align-items-center justify-content-center border-none p-button-sm" size='small'
                        >
                            {/* <Badge value="Solicitar código" size="large" severity="info" /> */}
                        </Button>

                    }
                    {!phone && <span><span className='font-bold'>Nota: </span>{warnMsg}</span>}
                </div><br />
                {(phoneChecked || mailChecked) &&
                    <>
                        <div id="recaptcha-container" key={captchaKey}></div>
                        {confirmation && (
                            <>
                                <InputText
                                    type="text"
                                    placeholder="Ingrese el código"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                />{" "}
                                <Button onClick={verifyOtp} loading={loadVerify} label="Verificar código" />
                            </>
                        )}
                        {mailConfirmation && (
                            <>
                                <InputText
                                    type="text"
                                    placeholder="Ingrese el código"
                                    value={mailOtp}
                                    onChange={(e) => setMailOtp(e.target.value)}
                                />{" "}
                                <Button onClick={verifyMailOtp} loading={loadVerify} label="Verificar código" />
                            </>
                        )}
                    </>}
            </Dialog>
            <Dialog visible={isOpenPhoto} header={"Foto para firma"} footer={photoFooter}
                position="top" draggable={false} resizable={false} modal onHide={() => hideModalPhoto(false)}>
                {
                    !photo ? 
                    <div
                        style={{
                            width: isMobile ? "100%" : isTablet ? "380px" : "600px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                        >
                        <Webcam
                            audio={false}
                            screenshotFormat="image/jpeg"
                            videoConstraints={videoConstraints}
                            mirrored={false}
                            style={{
                                width: "100%",
                                aspectRatio: isMobile ? "9/16" : "16/9",
                                maxHeight: isMobile ? "55vh" : "50vh",  
                                objectFit: "cover",
                                display: "block",
                                borderRadius: "4px",
                            }}
                        >
                            {({ getScreenshot }) => (
                                <Button
                                    icon='pi pi-camera'
                                    style={{ width: '100%' }}
                                    tooltip='Tomar foto'
                                    onClick={async () => {
                                        let imageSrc = isMobile
                                            ? getScreenshot()   // use whatever the camera is natively giving
                                            : getScreenshot({ width: 1280, height: 720 });
                                        imageSrc = isMobile ? await upscaleImage(imageSrc, 4) : imageSrc
                                        setPhoto(imageSrc);
                                    }}
                                />
                            )}
                        </Webcam>
                    </div>
                    :
                    <div style={{ width: isMobile ? '100%' : '600px' }}>
                        <img
                        src={photo}
                        alt='Tracking'
                        style={{
                            width: '100%',
                            maxHeight: '50vh',      // never taller than 60% of the viewport
                            aspectRatio: isMobile ? '9/16' : '16/9',
                            height: "auto",
                            objectFit: 'contain',   // changed: show the full image within the box
                            display: 'block',
                            borderRadius: '4px',
                        }}
                        />
                    </div>
                }
            </Dialog>
            <div className="mt-6">
                <SkeletonTable load={loadPage}>
                    <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="REQUESTS_ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['REQUESTS_ID', 'NOVELTY', 'CONTRACT_ID', 'CONTRACT',
                            'START_DATE', 'UNITY', 'END_DATE', 'TYPE', 'TIME', 'STATUS']}>
                        <Column field="DOCUMENT_ID" header="Documento" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                        <Column field="DOCUMENT_TYPE" header="Tipo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                        <Column field="EXPEDITION_DATE" header="Fecha generación" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                        <Column field="SIGNATURE_DESC" header="¿Debe firmar?'" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre" sortable></Column>
                        <Column field="SIGNATURE_DATE" header="Feha firma" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
                        <Column field="NAME_FILE" header="Nombre archivo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por días" sortable></Column>
                        <Column field="STATUS" header="Estado" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                        <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                    </DataTable>
                </SkeletonTable>
            </div>
        </div>
    );
};

export default DocumentSigning;
